const base = {
  COOKIE_NAME: 'hello-pgmta',
};

const development = {
  ...base,
  API_HOST: 'http://localhost:30001',
};

const production = {
  ...base,
  API_HOST: process.env.REACT_APP_API_HOST,
};

const env = process.env.REACT_APP_STAGE || 'development';
export default env === 'production' ? production : development;
